import lifeTimeMembership1 from "../../../assets/images/life-time-membership1.jpg";
import lifeTimeMembership2 from "../../../assets/images/life-time-membership2.jpg";

export const lifeTimeMembershipImages = [
  {
    id: 1,
    image: lifeTimeMembership1,
  },
  {
    id: 2,
    image: lifeTimeMembership2,
  },
];

export const lifeTimeMembership = [
  "The Life Patron programme allows you to become a member of ISKCON’s international family. In the early 1970s, the founder-Acharya of ISKCON, His Divine Grace A.C. Bhaktivedanta Swami Prabhupad, introduced this programme. He invited anyone who wanted to serve Krishna to become an ISKCON Life patron. Many people want to join ISKCON and devote their lives to Krishna, but they are unable to do so due to family or other responsibilities. The Life Patron programme was created to allow anyone to contribute to ISKCON’s preaching activities while remaining at home with their families. They may reside in ISKCON temples around the world for a few days each year and participate in ISKCON’s activities.Presently more than 50,000 Life Members are part of ISKCON’s family.",

  "To know more about Life Membership program and to become one kindly contact: ",
];

export const contactDetails = [
  {
    id: 1,
    number: "+91 9998407654",
  },
];
